// Capture the auth landing type from the URL hash at module load — BEFORE the
// Supabase client (`detectSessionInUrl`, on by default) consumes and strips the
// hash. Invite and password-recovery links must route to the set-password
// screen; magic-link (founders' passwordless sign-in, `type=magiclink`) must
// flow straight through to the app.

function readIsInviteLanding(): boolean {
  if (typeof window === 'undefined') return false
  const hashType = new URLSearchParams(window.location.hash.replace(/^#/, '')).get('type')
  return hashType === 'invite' || hashType === 'recovery'
}

// Mutable on purpose: the flag must be consumable exactly once. AuthProvider's
// effect depends on `navigate`, whose identity changes on every location change
// under <BrowserRouter> (react-router 7 non-data router), so the effect re-runs
// after each navigation. A permanent `true` would bounce the user back to the
// set-password screen forever.
let pendingInviteLanding = readIsInviteLanding()

/**
 * Return whether an invite/recovery landing is pending, and clear the flag so
 * later effect re-runs cannot redirect a second time.
 */
export function consumePendingInviteLanding(): boolean {
  const pending = pendingInviteLanding
  pendingInviteLanding = false
  return pending
}

/** Re-read the flag from the current URL hash (test helper, cf. resetMeCache). */
export function resetInviteLanding(): void {
  pendingInviteLanding = readIsInviteLanding()
}
